import React, { useEffect, useState, useMemo,useCallback,useContext} from 'react';
import { Link, useNavigate } from "react-router-dom";
import { useParams } from 'react-router-dom';
import axios from 'axios';
import styles from './css/user.module.css';
import apiurl from '../Api';
import Swal from 'sweetalert2';
import Select from 'react-select';
import $ from 'jquery';
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/themes/light.css";
import ReactQuill from "react-quill-new";
import "react-quill-new/dist/quill.snow.css";
import RefreshContext from './RefreshContext';
import {
  Box, 
   Button, 
  Select as MuiSelect,
  MenuItem, 
  Typography, 
  Tooltip, 
  TextField,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableSortLabel,
  IconButton,
  Menu,
  ListItemIcon,} from '@mui/material'; 
import { ArrowDropDown, ArrowDropUp, MoreVert as MoreVertIcon,DeleteOutline, EditOutlined, VisibilityOutlined, KeyboardArrowRight, FormatListBulleted, PeopleAltOutlined, ArrowBackIosNew } from '@mui/icons-material';

function SelfRequire({ lineupMode = '' }) {
  const navigate = useNavigate();
    const { refreshKey } = useContext(RefreshContext);
  
  const [requirement, setRequirement] = useState(null);
  const [ivrdata,setIvrData] = useState("");
  const [ivr,setIvr] = useState("");

  const { aid,camptype } = useParams();

  const [staff, setStaff] = useState([]);
  const [total, setTotal] = useState(0);

      const [loading, setTableLoading] = useState(true);
      const [order, setOrder] = useState('asc'); 
      const [orderBySelector, setOrderBySelector] = useState(() => (row) => row.rid); 
      const [globalFilterText, setGlobalFilterText] = useState('');
      const [columnFilters, setColumnFilters] = useState({});
      const [stats,setStats]= useState([]);
    
  const [metaData, setMetaData] = useState({
    appname: '',
    edit: false,
    del: false,
    add: false,
    view: false,
    typess: '', request:false, crequest:false,
    icon: '',
    defaultShow: 10,
    bd:false,manager:false,uploadCandidates:false,vendor:false,
    showManager:false,
    poa:false
  });
 
 
 const [currentPage, setCurrentPage] = useState(1);
 const [totalRows, setTotalRows] = useState(0); // Set this from your API response
 const limit = 50; 
 const maxPage = Math.ceil(totalRows / limit);
 const [isSubmitting, setIsSubmitting] = useState(false);
 
   const fetchData = async (page) => {
    const response = await axios.get(apiurl + 'linerequirement.php?subdomain=react&aid=' + aid+"&page="+page); // Replace with your API endpoint
   
    setStaff(response.data.staff);

    setMetaData({
      appname: response.data.appname,
      edit: response.data.edit,
      del: response.data.del,
      add: response.data.add,
      view: response.data.view,
      typess: response.data.typess,
      icon: response.data.icon,
      defaultShow: response.data.defaultShow,
      bd:response.data.bd,
      manager:response.data.manager,
      uploadCandidates:response.data.uploadCandidates,
      vendor:response.data.vendorShow,
      showManager:response.data.showManager,
      poa:response.data.poa,
      request:response.data.request, crequest:response.data.crequest
    });
    setStats(response.data.stats);
    setTableLoading(false);
  };

   //edit the form
  const EditData = async (edit, sss) => {
    if (edit) {
      setLoading(true);
      try {
        const response = await axios.get(apiurl + 'linerequirement.php?edit=' + edit+"&tt="+camptype);
        if (response.data.status == true) {
            if(sss==='2'){ 
               setRequirement(response.data.data[0]);
               $("#tera_modal3").click();
            }
            else{
               setIvrData(response.data.data[0]);
               setIvr(response.data.data[0].reqhidden);
               $("#tera_modal").click();
            }
          
           setLoading(false);
        } else {
          // modal can't show
          setLoading(false);
          alert("data not found");
        }

      }
      catch (error) {
        console.error('Error deleting category:', error);
      }

    }

  };

const displayCount = 5;
let startPage = Math.max(1, currentPage - Math.floor(displayCount / 2));
let endPage = startPage + displayCount - 1;

if (endPage > maxPage) {
    endPage = maxPage;
    startPage = Math.max(1, endPage - displayCount + 1);
}

const pages = [];
for (let i = startPage; i <= endPage; i++) {
    pages.push(i);
}

  
  useEffect(() => {
    fetchData(currentPage);
     document.title = lineupMode === 'selectedCandidates'
       ? "Selected Candidates | MERAQUI"
       : camptype === '3' || lineupMode === 'campaignCandidate'
       ? "Candidate Line Up | MERAQUI"
       : (aid === '112' ? "Line up Requirement | MERAQUI" : "Request Campaign");
  }, [aid,camptype,refreshKey,lineupMode]);

    const isCandidateLineup = camptype === '3' || lineupMode === 'campaignCandidate' || lineupMode === 'selectedCandidates';
    const lineupPageTitle = lineupMode === 'selectedCandidates' ? 'Selected Candidates' : 'Candidate Line Up';
    const typeUpper = metaData.typess?.toUpperCase();
    const dynamicFilterOptions = useMemo(() => {
          const options = {};
          const selectAccessors = ['contract', 'pType', 'rstatus'];
          
          selectAccessors.forEach(key => {
              const uniqueValues = new Set();
              staff.forEach(row => {
                  if (row[key]) {
                      uniqueValues.add(row[key]);
                  }
              });
              options[key] = Array.from(uniqueValues).sort();
          });
          return options;
      }, [staff]);
  
      const shouldIncludeActionColumn = (
          metaData.typess?.toUpperCase() === "STAFF" || aid === '202'
  );
  
  const stableSort = (array, comparator) => {
      const stabilizedThis = array.map((el, index) => [el, index]);
      stabilizedThis.sort((a, b) => {
          const order = comparator(a[0], b[0]);
          if (order !== 0) {
              return order;
          }
          return a[1] - b[1];
      });
      return stabilizedThis.map((el) => el[0]);
  };
  
  const getComparator = (order, orderBy) => {
      return order === 'desc'
          ? (a, b) => descendingComparator(a, b, orderBy)
          : (a, b) => -descendingComparator(a, b, orderBy);
  };
  
  const descendingComparator = (a, b, orderBy) => {
      const valA = orderBy(a);
      const valB = orderBy(b);
  
      if (valB < valA) {
          return -1;
      }
      if (valB > valA) {
          return 1;
      }
      return 0;
  };
 
 const ColumnHeaderWithFilter = ({
    column,
    orderBySelector,
    order,
    handleRequestSort,
    columnFilters,
    setColumnFilters,
}) => {

    const accessorKey = column.accessorKey;
    const isSortable = !!column.selector;
    const isFilterable = !!column.filterType;
    const isSorted = orderBySelector === column.selector;

    const [anchorEl, setAnchorEl] = useState(null);
    const [localOpenKey, setLocalOpenKey] = useState(null);

    // ✅ Temporary input state (important)
    const [tempFilterValue, setTempFilterValue] = useState(
        columnFilters[accessorKey] || ''
    );

    const isMenuOpen = localOpenKey === accessorKey;
    const currentFilter = columnFilters[accessorKey] || '';

    // Sync temp value when filter changes externally
    useEffect(() => {
        setTempFilterValue(currentFilter);
    }, [currentFilter]);

    const handleClick = (event) => {
        event.stopPropagation();
        setAnchorEl(event.currentTarget);
        setLocalOpenKey(accessorKey);
    };

    const handleClose = () => {
        setAnchorEl(null);
        setLocalOpenKey(null);
    };

    // ✅ Apply filter only when Search clicked
    const applyFilter = () => {
        setColumnFilters(prev => ({
            ...prev,
            [accessorKey]: tempFilterValue
        }));
        handleClose();
    };

    // --- Custom Filter Input Renderer ---
    const renderFilterInput = () => {

        if (column.filterType === 'select') {
            const filterOptions = column.dynamicFilterOptions || [];

            return (
                <MuiSelect
                    value={tempFilterValue}
                    onChange={(e) => setTempFilterValue(e.target.value)}
                    size="small"
                    fullWidth
                >
                    <MenuItem value="">— All —</MenuItem>
                    {filterOptions.map(option => (
                        <MenuItem key={option} value={option}>
                            {option}
                        </MenuItem>
                    ))}
                </MuiSelect>
            );
        }

        if (column.filterType === 'date') {
            return (
                <TextField
                    type="date"
                    size="small"
                    value={tempFilterValue}
                    onChange={(e) => setTempFilterValue(e.target.value)}
                    InputLabelProps={{ shrink: true }}
                    fullWidth
                />
            );
        }

        // Default: text filter
        return (
            <TextField
                label={`Filter ${column.header}`}
                variant="outlined"
                size="small"
                value={tempFilterValue}
                onChange={(e) => setTempFilterValue(e.target.value)}
                onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                        applyFilter();
                    }
                }}
                autoFocus
                fullWidth
            />
        );
    };

    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                width: '100%',
                '& .MuiTableSortLabel-root': { flexGrow: 1 }
            }}
        >
            {/* Sorting */}
            <TableSortLabel
                active={isSorted}
                direction={isSorted ? order : 'asc'}
                onClick={() => isSortable && handleRequestSort(column.selector)}
                IconComponent={
                    isSorted
                        ? (order === 'desc' ? ArrowDropDown : ArrowDropUp)
                        : undefined
                }
                sx={{
                    cursor: isSortable ? 'pointer' : 'default',
                    justifyContent: column.headerAlign === 'center' ? 'center' : 'flex-start',
                    '&.Mui-active': {
                        color: 'primary.main',
                        fontWeight: 'bold',
                    }
                }}
            >
                {column.header}
            </TableSortLabel>

            {/* Filter Button */}
            {isFilterable && (
                <>
                    <IconButton
                        size="small"
                        onClick={handleClick}
                        sx={{
                            ml: 1,
                            p: 0,
                            color: currentFilter
                                ? 'primary.main'
                                : 'text.secondary',
                        }}
                    >
                        <MoreVertIcon fontSize="inherit" />
                    </IconButton>

                    <Menu
                        anchorEl={anchorEl}
                        open={isMenuOpen}
                        onClose={handleClose}
                        onClick={(e) => e.stopPropagation()}
                        PaperProps={{
                            sx: { width: 250, p: 2, boxShadow: 6, borderRadius: 2 }
                        }}
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'left'
                        }}
                        transformOrigin={{
                            vertical: 'top',
                            horizontal: 'left'
                        }}
                    >
                        <Box sx={{ width: '100%' }}>
                            {renderFilterInput()}
                        </Box>

                        {/* Search Button */}
                        <Button
                            variant="contained"
                            size="small"
                            sx={{ mt: 2, textTransform: 'none', width: '100%' }}
                            onClick={applyFilter}
                        >
                            Search
                        </Button>

                        {/* Clear Button */}
                        {currentFilter && (
                            <Button
                                onClick={() => {
                                    setColumnFilters(prev => ({
                                        ...prev,
                                        [accessorKey]: ''
                                    }));
                                    handleClose();
                                }}
                                size="small"
                                color="error"
                                sx={{ mt: 1, textTransform: 'none', width: '100%' }}
                            >
                                Clear Filter
                            </Button>
                        )}
                    </Menu>
                </>
            )}
        </Box>
    );
};
  
    const columns = useMemo(() => {
          let baseColumns = [
              { accessorKey: 'rid', header: 'Req. ID', size: 300, selector: (row) => row.rid, filterType: 'text', headerAlign: 'center' },
              { accessorKey: 'action', header: 'Action', size: 160 },
              { accessorKey: 'recname', header: 'BD Name', size: 150, selector: (row) => row.recname, filterType: 'text' },
              { accessorKey: 'name', header: 'Client Name', size: 150, selector: (row) => row.name, filterType: 'text' },
              { 
                  accessorKey: 'contract', 
                  header: 'Contract', 
                  size: 150, 
                  selector: (row) => row.contract, 
                  filterType: 'select', 
                  dynamicFilterOptions: dynamicFilterOptions['contract'] 
              },
              { 
                  accessorKey: 'pType', 
                  header: 'PlacementType', 
                  size: 150, 
                  selector: (row) => row.pType, 
                  filterType: 'select',
                  dynamicFilterOptions: dynamicFilterOptions['pType']
              },
              { accessorKey: 'position', header: 'No. of Position', size: 100, selector: (row) => row.position },
              { 
                  accessorKey: 'planDates', 
                  header: 'Plan Dates', 
                  size: 150, 
                  selector: (row) => row.planDates, 
                  filterType: 'date' 
              },
              { 
                  accessorKey: 'rstatus', 
                  header: 'Requirement Status', 
                  size: 150, 
                  selector: (row) => row.rstatus, 
                  filterType: 'select',
                  dynamicFilterOptions: dynamicFilterOptions['rstatus']
              },
              { accessorKey: 'location', header: 'Location', size: 150, selector: (row) => row.location, filterType: 'text' },
              { 
                  accessorKey: 'date', 
                  header: 'Request Time', 
                  size: 150, 
                  selector: (row) => row.date, 
                  filterType: 'date' 
              },
          ];
          return baseColumns;
      }, [ dynamicFilterOptions,shouldIncludeActionColumn,navigate, aid]); 
  
      const handleChange = useCallback((hiddenId, newStatus) => {
          console.log(`Updating request ${hiddenId} status to: ${newStatus}`);
          setStaff(prevData => prevData.map(row => 
              row.hidden === hiddenId ? { ...row, statues: newStatus } : row
          ));
      }, []);
  
      const handleRequestSort = useCallback((selector) => {
          const isAsc = orderBySelector === selector && order === 'asc';
          setOrder(isAsc ? 'desc' : 'asc');
          setOrderBySelector(() => selector);
      }, [order, orderBySelector]);
  
      const processedData = useMemo(() => {
          let filtered = staff;
          const lowerCaseFilter = globalFilterText.toLowerCase();
  
          // 1. Apply Global Filter
          if (lowerCaseFilter) {
              filtered = filtered.filter(row => 
                  columns.some(column => {
                      const value = column.selector ? String(column.selector(row)) : '';
                      return value.toLowerCase().includes(lowerCaseFilter);
                  })
              );
          }
  
          // 2. Apply Column Filters
          filtered = filtered.filter(row => {
              return columns.every(column => {
                  const accessorKey = column.accessorKey;
                  const filterValue = columnFilters[accessorKey];
  
                  if (!filterValue) return true;
                  if (!column.selector) return true;
  
                  const rowValue = String(column.selector(row));
  
                  switch (column.filterType) {
                      case 'select':
                          // Must match the selected value exactly
                          return rowValue === filterValue; 
                          
                      case 'date':
                          // Check if the date string (e.g., '2024-01-15') includes the filter date
                          return rowValue.includes(filterValue); 
                          
                      case 'text':
                      default:
                          // Standard case-insensitive string inclusion
                          return rowValue.toLowerCase().includes(filterValue.toLowerCase());
                  }
              });
          });
  
          // 3. Sorting Logic
          const sortColumn = columns.find(col => col.selector === orderBySelector);
  
          if (sortColumn) {
              return stableSort(filtered, getComparator(order, sortColumn.selector));
          }
          
          return filtered;
  
      }, [staff, columns, order, orderBySelector, globalFilterText, columnFilters]);
  
  
  const RenderReqIdCell = useCallback(({ row }) => {
      const rowData = row;
      
      const isViewDetailClickable = true; // Set to true or use metaData.view check if needed
      let click=true;
      
      let statsColor = '#10B981'; // Default: Green
      if (rowData.rstatus.toLowerCase() === 'onhold') {
          statsColor = '#eb0a0aff'; // Amber
          click=false;
      } else if (rowData.rstatus.toLowerCase() === 'closed') {
          statsColor = '#e26206ff'; // Gray
          click=false;
      }
    
      return (
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, whiteSpace: 'nowrap',minWidth: 170 }}>
  
             <Tooltip title={isViewDetailClickable ? 'View Detail' : ''} arrow>
                  <IconButton
                      size="small"
                      onClick={() => EditData(rowData.hidden, "2")} 
                      disabled={!isViewDetailClickable}
                      sx={{
                          color: 'orange', 
                          p: 0.5,
                          '&:hover': {
                              color: isViewDetailClickable ? '#0056b3' : 'text.disabled',
                              backgroundColor: 'transparent'
                          }
                      }}
                  >
                      <VisibilityOutlined sx={{ fontSize: '1rem' }} />
                  </IconButton>
              </Tooltip>
  
  <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
   <Button
      sx={{
        background: "none",
        border: "none",
        color: statsColor,
        padding: 0,
        minWidth: 0,
        fontWeight: 500,
        textAlign: 'left',
        textTransform: 'none',
        fontSize: '0.875rem',
        '&:hover': { backgroundColor: 'transparent' }
      }}
    >
      {rowData.rid}
    </Button>


</Box></Box>
);
  }, [navigate, EditData, camptype, aid]); // Make sure EditData is included in the dependencies
 
  const setLoading = (show) => {
    if (show) {
      $("#showLoader").removeClass("d-none").addClass("d-flex");
    } else {
      $("#showLoader").removeClass("d-flex").addClass("d-none");
    }
  };
 
  const PaidCamp = async (e) => {
    e.preventDefault();
    if (isSubmitting) return; // hard lock
  try {
      setIsSubmitting(true);

      $("#showLoader").removeClass("d-none").addClass("d-flex");
      const formData1 = new FormData($("#submitform")[0]); 
      formData1.append("lineupcandidateid", ivrdata.hidden);
      const res = await axios.post(apiurl+'allotement.php', formData1);
      
      if (res.data.status) {
        Swal.fire({
          icon: 'success',
          title: res.data.message,
          timer: 1500,
          showConfirmButton: false,
        }).then(()=>{
           $("#exampleModal .btn-close").click();
           setTimeout(() => {
                navigate(-1);
            }, 300);
        });
       
      } else {
        Swal.fire("Error", res.data.message, "error");
      }

  } catch (err) {
    console.error("Error:", err);
    Swal.fire("Error", "Server connection failed!", "error");
  } finally {
    $("#showLoader").removeClass("d-flex").addClass("d-none");
    setIsSubmitting(false);
  }
};

  return (
    <>
      {/* modal all */}
      <button data-bs-toggle="modal" id="tera_modal3" data-bs-target="#tableModal" type="button" style={{ display: 'none' }}></button>
   
      <button data-bs-toggle="offcanvas" id="tera_modal" data-bs-target="#exampleModal" type="button" style={{ display: 'none' }}></button>
     
          <div className="offcanvas offcanvas-top" style={{ maxHeight: '100%', height: 'auto', backgroundColor: 'rgb(245 245 245)' }} tabIndex="-1" id="exampleModal"  data-bs-keyboard="false">
             <div className="offcanvas-header border-bottom border-block-end-dashed">
               <h5 className="offcanvas-title" id="offcanvasRightLabel1">Paid Lead Campaign</h5>
               <button type="button" className="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
             </div>
             <div className="offcanvas-body" style={{ paddingBottom: '80px' }}>
     
     <div className='d-flex'>
     
     <div style={{position:'relative',marginBottom:'50px',width:'75%'}}>
     
     <form id="submitform" encType="multipart/form-data" className='order-2' onSubmit={PaidCamp}>
                <div className="row g-3">
                <div className="col-xl-3 col-lg-3 col-md-6 mb-2">
                   <label htmlFor="requireid" className="form-label">Requirement Id</label>
                   <input defaultValue={ivrdata.rid || ""} name='requireid' type="text" className="form-control" placeholder="Require ID" readOnly disabled/>
                 </div>
                
                 <div className="col-xl-4 col-lg-4 col-md-6 mb-2">
                   <label htmlFor="client" className="form-label">Client Name</label>
                   <input defaultValue={ivrdata.cidd || ""} type="text" className="form-control" placeholder="Client name" readOnly disabled/>
                 </div>
     
                 <div className="col-2 mb-3">
                   <label className="form-label">Requirement Details</label>
                   <button className="btn btn-link" type="button"  data-bs-toggle="collapse" data-bs-target="#moreInfoCollapse" aria-expanded="false" aria-controls="moreInfoCollapse" style={{ textDecoration: 'none' }}>
                       <span className="me-2">More Details...</span> 
                          <i className="bi bi-chevron-down"></i> 
                  </button>
                 </div>
             </div>
            <div className="collapse" id="moreInfoCollapse" style={{border: '2px solid rgb(215 226 255)',padding: '10px',marginBottom: '11px',borderRadius: '10px'}}>    
                 <div className='row'>
                 <div className="col-xl-4 col-lg-4 col-md-6 mb-2">
                   <label htmlFor="jobTitle" className="form-label">Requirement Name/Job Title</label>
                   <input defaultValue={ivrdata.jobTitle || ""} type="text" className="form-control" placeholder="JOB TITLE" readOnly disabled/>
                 </div>
                 <div className="col-xl-4 col-lg-4 col-md-6 mb-2">
                   <label htmlFor="jobTitle" className="form-label">Requirement Location</label>
                   <input defaultValue={ivrdata.location || ""} type="text" className="form-control" placeholder="Location" readOnly disabled/>
                 </div>
                 
                 <div className="col-xl-4 col-lg-4 col-md-6 mb-2">
                   <label htmlFor="recName" className="form-label">Rec Name</label>
                   <input defaultValue={ivrdata.recname || ""} type="text" className="form-control" placeholder="Rec Name" readOnly disabled/>
                 </div>
     
                 <div className="col-xl-4 col-lg-4 col-md-6 mb-2">
                   <label htmlFor="cost" className="form-label">Cost Center</label>
                   <input defaultValue={ivrdata.costCenter || ""} type="text" className="form-control" placeholder="Cost Center" readOnly disabled/>
                 </div>
     
                  <div className="col-xl-4 col-lg-4 col-md-6 mb-2">
                   <label htmlFor="rname" className="form-label">Qualification</label>
                   <input defaultValue={ivrdata.education || ""} type="text" className="form-control" placeholder="Education" readOnly disabled/>
                 </div>
     
                 <div className="col-xl-4 col-lg-4 col-md-6 mb-2">
                   <label htmlFor="remail" className="form-label">Experience Group</label>
                   <input defaultValue={ivrdata.expRange || ""} type="text" className="form-control" placeholder="Experience" readOnly disabled/>
                 </div>
                   <div className="col-xl-4 col-lg-4 col-md-6 mb-2">
                   <label htmlFor="spocPersonId" className="form-label">Age Group</label>
                   <input defaultValue={ivrdata.ageRange || ""} type="text" className="form-control" placeholder="Age Group" readOnly disabled/>
                 </div>
               
                 <div className="col-xl-4 col-lg-4 col-md-6 mb-2">
                   <label htmlFor="lineRequestDate" className="form-label">Gender</label>
                   <input defaultValue={ivrdata.gender || ""} type="text" className="form-control" placeholder="Gender" readOnly disabled/>
                 </div>
                
                 <div className="col-xl-4 col-lg-4 col-md-6 mb-2">
                   <label htmlFor="interviewDate" className="form-label">Keywords</label>
                   <input defaultValue={ivrdata.keywords || ""} type="text" className="form-control" placeholder="Keywords" readOnly disabled/>
                 </div>
                        <div className="col-12 mb-3">
            <label htmlFor="jobDescription" className="form-label">Job Description</label>
            <div 
                className="form-control" 
                style={{ height: 'auto', maxHeight: '200px', overflowY: 'auto', backgroundColor: 'white' }} 
                dangerouslySetInnerHTML={{ __html: ivrdata.jobDescription || "No job description provided." }}
            />
        </div>
                 </div>
             </div> 

             <div className='row g-3 mt-0'> 
                    {/* PAY ROLL = TEXT */}
                    <div className="col-xl-4 col-lg-4 col-md-6 mb-2 mt-0">
                        <label htmlFor="payroll" className="form-label">Pay Roll</label>
                        <input name='payroll' type="text" className="form-control" placeholder="Enter Pay Roll Type" required/>
                    </div>
                    
                    {/* DOMAIN = TEXT */}
                    <div className="col-xl-4 col-lg-4 col-md-6 mb-2 mt-0">
                        <label htmlFor="domain" className="form-label">Domain</label>
                        <input name='domain' type="text" className="form-control" placeholder="Enter Job Domain" required/>
                    </div>
                    
                    {/* INDUSTRY = TEXT */}
                    <div className="col-xl-4 col-lg-4 col-md-6 mb-2 mt-0">
                        <label htmlFor="industry" className="form-label">Industry</label>
                        <input name='industry' type="text" className="form-control" placeholder="Enter Industry Type" required/>
                    </div>
                    
                    {/* SHIFT TIME = TIME */}
                    <div className="col-xl-4 col-lg-4 col-md-6 mb-2">
                        <label htmlFor="shiftTime" className="form-label">Shift Time</label>
                        <input name='shiftTime' type="time" className="form-control" placeholder="Select Shift Time" required/>
                    </div>
                    
                    {/* CITY = TEXT */}
                    <div className="col-xl-4 col-lg-4 col-md-6 mb-2">
                        <label htmlFor="jobCity" className="form-label">City</label>
                        <input name='jobCity' type="text" className="form-control" placeholder="Enter City" required/>
                    </div>
                    
                    {/* STATE = TEXT */}
                    <div className="col-xl-4 col-lg-4 col-md-6 mb-2">
                        <label htmlFor="jobState" className="form-label">State</label>
                        <input name='jobState' type="text" className="form-control" placeholder="Enter State" required/>
                    </div>

                    {/* COUNTRY = TEXT */}
                    <div className="col-xl-4 col-lg-4 col-md-6 mb-2">
                        <label htmlFor="jobCountry" className="form-label">Country</label>
                        <input name='jobCountry' type="text" className="form-control" placeholder="Enter Country" />
                    </div>
                    
                    {/* INTERVIEW LOCATION DATE/TIME = DATETIME-LOCAL */}
                    <div className="col-xl-4 col-lg-4 col-md-6 mb-2">
                        <label htmlFor="interviewDateTime" className="form-label">Interview Date/Time</label>
                        <input name='interviewDateTime' type="datetime-local" className="form-control" required />
                    </div>
                    
                    {/* Specify Qualification = TEXT */}
                    <div className="col-xl-4 col-lg-4 col-md-6 mb-2">
                        <label htmlFor="specifyQualification" className="form-label">Specify Qualification</label>
                        <input name='specifyQualification' type="text" className="form-control" placeholder="e.g., B.Tech, MBA" required/>
                    </div>
                    
                    {/* SKILLS = TEXT */}
                    <div className="col-xl-4 col-lg-4 col-md-6 mb-2">
                        <label htmlFor="skills" className="form-label">Skills</label>
                        <input name='skills' type="text" className="form-control" placeholder="Enter Required Skills (Comma Separated)" required/>
                    </div>
                    
                    {/* OTHER BENEFITS = TEXT */}
                    <div className="col-xl-4 col-lg-4 col-md-6 mb-2">
                        <label htmlFor="otherBenefits" className="form-label">Other Benefits</label>
                        <input name='otherBenefits' type="text" className="form-control" placeholder="e.g., Insurance, Bonus" />
                    </div>
                    
                    {/* CONCERN PERSON = TEXT */}
                    <div className="col-xl-4 col-lg-4 col-md-6 mb-2">
                        <label htmlFor="concernPerson" className="form-label">Concern Person</label>
                        <input name='concernPerson' type="text" className="form-control" placeholder="Enter Concern Person Name" />
                    </div>
                    
                    {/* CONTACT NO = TEXT */}
                    <div className="col-xl-4 col-lg-4 col-md-6 mb-2">
                        <label htmlFor="contactNo" className="form-label">Contact No</label>
                        <input name='contactNo' type="text" className="form-control" placeholder="Enter Contact Number" />
                    </div>
                    
                    {/* CANDIDATE SOURCING LOCATION = TEXT */}
                    <div className="col-xl-4 col-lg-4 col-md-6 mb-2">
                        <label htmlFor="sourcingLocation" className="form-label">Candidate Sourcing Location</label>
                        <input name='sourcingLocation' type="text" className="form-control" placeholder="Enter Sourcing Location" />
                    </div>
                    
                    {/* QUESTION = TEXT (Using a textarea for better input) */}
                    <div className="col-xl-4 col-lg-4 col-md-6 mb-2">
                        <label htmlFor="question" className="form-label">Question</label>
                        <input name='question' type="text" className="form-control" placeholder="Add any screening questions" required/>
                    </div>

                    {/* SPOC PERSON ID = TEXT */}
                    <div className="col-xl-4 col-lg-4 col-md-6 mb-2">
                        <label htmlFor="spocPersonIdEditable" className="form-label">SPOC Person ID</label>
                        <input name='spocPersonIdEditable' type="text" className="form-control" placeholder="Enter SPOC Person ID" required/>
                    </div>
                    
                    {/* SPOC PERSON NAME = TEXT */}
                    <div className="col-xl-4 col-lg-4 col-md-6 mb-2">
                        <label htmlFor="spocPersonName" className="form-label">SPOC Person Name</label>
                        <input name='spocPersonName' type="text" className="form-control" placeholder="Enter SPOC Person Name" required/>
                    </div>
                    
                    {/* BUSINESS HEAD = TEXT */}
                    <div className="col-xl-4 col-lg-4 col-md-6 mb-2">
                        <label htmlFor="businessHead" className="form-label">Business Head</label>
                        <input name='businessHead' type="text" className="form-control" placeholder="Enter Business Head Name" required/>
                    </div>
                    
                    {/* RECRUITING FEE = TEXT */}
                    <div className="col-xl-4 col-lg-4 col-md-6 mb-2">
                        <label htmlFor="recruitingFee" className="form-label">Recruiting Fee</label>
                        <input name='recruitingFee' type="text" className="form-control" placeholder="Enter Recruiting Fee" required/>
                    </div>
                   
    </div>
    
     <div className="wizard-footer">
             <button type="button" className="btn prev-btn">
                 Cancel
             </button>
             <button type="submit" className="btn next-btn" value={isSubmitting ? "Processing..." : "Submit"} disabled={isSubmitting}>
                 Request
             </button>
     </div>
     <input type="hidden" name="hidden" id="hiddenss" />
     
     </form>
     
      </div>
           <img className="order-2" src={process.env.PUBLIC_URL + "/admin_assets/images/media/onboard.svg"} style={{ width: '25%', height: '100%' }} />
         </div>    
           
     
             </div>
     
           </div>
     
     
          <div className="modal effect-super-scaled fade" id="tableModal" tabIndex="-1" data-bs-backdrop="static" aria-labelledby="tableModal" aria-hidden="true">
             <div className="modal-dialog modal-xl">
               <div className="modal-content">
                 <div className="modal-body" style={{maxHeight:'90vh',overflowX:'auto'}}>
     <h5><strong>Requirement Detail</strong></h5>
     
     <table className="table table-bordered" style={{ tableLayout: "fixed" }}>
       <tbody>
         {requirement && [
           ["RecID", "Branch", "CTC ", "", requirement.rid, requirement.branchh, requirement.ctcRange,""],
           ["Gender", "RecName", "Age", "Requirement Plan Dates", requirement.gender?.toUpperCase(), requirement.recname, requirement.ageRange, requirement.planDate],
           ["Client Name", "Anchor", "Location", "Experience", requirement.cidd, requirement.anchor, requirement.location, requirement.expRange],
           ["Education Type", "Commercials", "Designation", "Contact Name", requirement.education, requirement.commercials, requirement.posts, requirement.contactName],
           ["Contract", "Placement Type", "Job Title", "Requirement Status", requirement.contract, requirement.placementType, requirement.jobTitle, requirement.statuses],
           ["Cost Center", "Requirement Create Time", "No Of Position", "Pincode", requirement.costCenterbig, requirement.datestimes, requirement.noOfPosition, requirement.pincode],
         ].map((row, idx) => (
           <React.Fragment key={idx}>
             {/* Headings Row */}
             <tr>
               <th style={{ backgroundColor: "#e9ecef" }}>{row[0]}</th>
               <th style={{ backgroundColor: "#e9ecef" }}>{row[1]}</th>
               <th style={{ backgroundColor: "#e9ecef" }}>{row[2]}</th>
               <th style={{ backgroundColor: "#e9ecef" }}>{row[3]}</th>
             </tr>
     
             {/* Values Row */}
             <tr>
               <td>{row[4] || "-"}</td>
               <td>{row[5] || "-"}</td>
               <td>{row[6] || "-"}</td>
               <td>{row[7] || "-"}</td>
             </tr>
           </React.Fragment>
         ))}
     
         <tr>
            <th style={{ backgroundColor: "#e9ecef" }}>Keywords</th>
             <td colSpan="3">N/A</td>
         </tr>
       </tbody>
     </table>
     
     
     <h5 className="mt-4"><strong>Statistics Overview</strong></h5>
     {/* New Statistics Overview Table */}
     <table className="table table-bordered mt-4" style={{ tableLayout: 'fixed', width: '100%' }}>
       <tbody>
         {requirement && [
           ["Total Candidates", "Vendor Candidates", "Recruiter Candidates", requirement.tcandidate, requirement.vcandidate, requirement.rcandidate],
           ["Total Campaigns", "Campaign IVR Completed", "Campaign IVR Pending", requirement.tcampaign, requirement.isuccess, requirement.ipending],
           ["IVR Total Call ( Candidates )", "IVR Pending ( Candidates )", "IVR Completed ( Candidates )", requirement.ivrtotal, requirement.ivrpending, requirement.ivrcompleted],
           ["Lineups Candidates", "Selected Candidates", "Joined Candidates", requirement.lineup, requirement.selected, requirement.joined]
         ].map((row, idx) => (
           <>
             {/* Headings row */}
             <tr key={`st-head-${idx}`}>
               <th style={{ backgroundColor: "#e9ecef" }}>{row[0]}</th>
               <th style={{ backgroundColor: "#e9ecef" }}>{row[1]}</th>
               <th style={{ backgroundColor: "#e9ecef" }}>{row[2]}</th>
             </tr>
     
             {/* Values row */}
             <tr key={`st-val-${idx}`}>
               <td>{row[3]}</td>
               <td>{row[4]}</td>
               <td>{row[5]}</td>
             </tr>
           </>
         ))}
       </tbody>
     </table>
     
     
             
                 </div>
                 <div className='modal-footer' style={{ padding: '0px' }}>
                   <button type="button" className="btn btn-danger btn-sm" data-bs-dismiss="modal" id="okayClose" aria-label="Close">Close</button>
                 </div>
               </div>
             </div>
           </div>

      <div className="main-content app-content">

        <div className="container-fluid">

          {/* Page Header — breadcrumb only for candidate lineup views */}
          {isCandidateLineup ? (
            <div className="mt-4 mb-3">
              <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:'12px', flexWrap:'wrap', gap:'10px' }}>
                {/* macOS-style breadcrumb */}
                <div style={{ display:'inline-flex', alignItems:'center', gap:'2px', background:'#f1f5f9', borderRadius:'10px', padding:'5px 10px', border:'1px solid #e2e8f0' }}>
                  <button
                    onClick={() => navigate(`/admin/lineup/${aid}`)}
                    style={{ display:'inline-flex', alignItems:'center', gap:'5px', background:'none', border:'none', cursor:'pointer', padding:'4px 8px', borderRadius:'7px', fontSize:'0.82rem', fontWeight:500, color:'#334155', transition:'background 0.15s' }}
                    onMouseEnter={e => e.currentTarget.style.background='#e2e8f0'}
                    onMouseLeave={e => e.currentTarget.style.background='none'}
                  >
                    <FormatListBulleted sx={{ fontSize:'0.95rem', color:'#3b82f6' }} />
                    Line Up
                  </button>
                  <KeyboardArrowRight sx={{ fontSize:'1rem', color:'#94a3b8' }} />
                  <span style={{ display:'inline-flex', alignItems:'center', gap:'5px', padding:'4px 8px', borderRadius:'7px', fontSize:'0.82rem', fontWeight:600, color:'#1e293b', background:'#ffffff', border:'1px solid #cbd5e1' }}>
                    <PeopleAltOutlined sx={{ fontSize:'0.95rem', color:'#10b981' }} />
                    {lineupPageTitle}
                  </span>
                </div>
                {/* Back button */}
                <button
                  className="btn btn-primary"
                  onClick={() => navigate(`/admin/lineup/${aid}`)}
                  style={{ display:'inline-flex', alignItems:'center', gap:'6px', fontWeight:500, padding:'8px 20px', fontSize:'0.9rem' }}
                >
                  <ArrowBackIosNew sx={{ fontSize:'0.85rem' }} />
                  Back
                </button>
              </div>
              <h4 className="fw-semibold mb-0" style={{ fontSize:'1.25rem', color:'#1e293b' }}>{lineupPageTitle}</h4>
            </div>
          ) : (
            camptype !== '1' && camptype !== '2' && (
            <div className="mt-4 mb-3">
              <div style={{ display:'inline-flex', alignItems:'center', gap:'2px', background:'#f1f5f9', borderRadius:'10px', padding:'5px 10px', border:'1px solid #e2e8f0', marginBottom:'10px' }}>
                <button
                  onClick={() => navigate(`/admin/lineup/${aid}`)}
                  style={{ display:'inline-flex', alignItems:'center', gap:'5px', background:'none', border:'none', cursor:'pointer', padding:'4px 8px', borderRadius:'7px', fontSize:'0.82rem', fontWeight:500, color:'#334155', transition:'background 0.15s' }}
                  onMouseEnter={e => e.currentTarget.style.background='#e2e8f0'}
                  onMouseLeave={e => e.currentTarget.style.background='none'}
                >
                  <FormatListBulleted sx={{ fontSize:'0.95rem', color:'#3b82f6' }} />
                  Line Up
                </button>
                <KeyboardArrowRight sx={{ fontSize:'1rem', color:'#94a3b8' }} />
                <span style={{ display:'inline-flex', alignItems:'center', gap:'5px', padding:'4px 8px', borderRadius:'7px', fontSize:'0.82rem', fontWeight:600, color:'#1e293b', background:'#ffffff', border:'1px solid #cbd5e1' }}>
                  Requirements
                </span>
              </div>
              <h4 className="fw-semibold mb-0" style={{ fontSize:'1.25rem', color:'#1e293b' }}>Requirements</h4>
            </div>
            )
          )}

         <div className="row">

<div class="col-xl-12 mt-2">
    <div class="card custom-card">
        <div class="card-header" style={{display:'flex',justifyContent:'space-between'}}>
          <div class="card-title">{isCandidateLineup ? lineupPageTitle : 'Requirements'}</div>
        </div>
        <div class="card-body">
            <div class="row gy-md-0 gy-3">

 {stats.map((item, index) => (
 
 <div class="col-xxl-2 col-xl-2 col-lg-4 col-md-4 col-sm-12" key={index}>
                    <div class="d-flex align-items-top">
                        <div class="me-3">
                            <span class={"avatar avatar-rounded text-white"} style={{backgroundColor:item.color}}>
                                <i class={`${item.icon} fs-28`}></i>
                            </span>
                        </div>
                        <div>
                            <span class="d-block mb-1 text-muted">{item.label}</span>
                            <h6 class="fw-semibold mb-0">{item.count}</h6>
                        </div>
                    </div>
                </div>

  ))}

            </div>
        </div>
    </div>
</div>
 
</div>
          <div className="row">
            <div className="col-xxl-12 col-xl-12 ">
              <div className="card custom-card">
                <div className="card-header justify-content-between" style={{ paddingBottom: '15px', alignItems: 'normal' }}>
                  <div>
                    <h6 className="fs-16">{camptype==='1' ? 'Open Campaign' : camptype==='2' ? 'Paid Campaign ' : lineupPageTitle}</h6>
                  </div>
                  <div className="d-flex mt-sm-0 mt-2 align-items-center" style={{width:'35%'}}>

                    <div className="input-group" >
                      <input type="search" className="form-control" placeholder="Search Users" id="search-member" value={globalFilterText}
                    onChange={(e) => setGlobalFilterText(e.target.value)} />
                    </div>
               
               {metaData.add ===1 && typeUpper==='STAFF' && (
                      <button className="btn btn-icon btn-primary ms-2" data-bs-toggle="offcanvas" data-bs-target="#exampleModal" id='addStaffbtn' style={{
                        position: 'fixed', bottom: '20px', right: '20px', width: '4.313rem',
                        height: '4.313rem', borderRadius: '50%', zIndex: '1'
                      }}><i className="ri-add-line" style={{ fontSize: '35px' }}></i></button>
                )}
                             
                  </div>

                </div>
              
 <div className="card-body" style={{ padding: '0px' }}>

           <TableContainer sx={{ maxHeight: '700px'}}>
                <Table stickyHeader aria-label="requirement tracker table">
                    
                    <TableHead>
                        <TableRow>
                            {columns.map((column) => (
                                <TableCell
                                    key={column.accessorKey}
                                    sx={{ 
                                        whiteSpace: 'nowrap',
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        p: 2.5,
                                        fontSize: '0.85rem', 
                                        verticalAlign: 'top',
                                    }}>
                                    <ColumnHeaderWithFilter
                                        column={column}
                                        orderBySelector={orderBySelector}
                                        order={order}
                                        handleRequestSort={handleRequestSort}
                                        columnFilters={columnFilters}
                                        setColumnFilters={setColumnFilters}
                                    />
                                </TableCell>
                            ))}
                        </TableRow>
                    </TableHead>

                    <TableBody>
                        {processedData.map((row, index) => (
                            <TableRow 
                                key={index} 
                                
                            >
                                {columns.map((column) => {
                                    const value = column.selector ? column.selector(row) : null;
                                    
                                    let cellContent;

                                    if (column.accessorKey === 'rid') {
                                        cellContent = <RenderReqIdCell row={row} />;
                                    }
                                    else if (column.accessorKey === 'action') {
                                        const canClick = !(row.rstatus.toLowerCase() === 'onhold' || row.rstatus.toLowerCase() === 'closed');
                                        const btnLabel = (camptype == '1' || camptype == '2') ? 'Request Campaign' : 'Line Up';
                                        const btnAction = lineupMode === 'selectedCandidates'
                                            ? () => navigate(`/admin/alllineup/${row.hidden}/113`)
                                            : camptype == '3'
                                                ? () => navigate(`/admin/candidate/${row.hidden}/10`)
                                                : camptype == '1'
                                                    ? () => navigate(`/admin/candidate/${row.hidden}/${aid}`)
                                                    : camptype == '2'
                                                        ? () => EditData(row.hidden, "1")
                                                        : () => navigate(`/admin/candidate/${row.hidden}/10`);
                                        cellContent = (
                                            <Box sx={{ display: 'flex', justifyContent: 'flex-start' }}>
                                                <Button
                                                    variant="contained"
                                                    size="small"
                                                    disabled={!canClick}
                                                    onClick={canClick ? btnAction : undefined}
                                                    sx={{ textTransform: 'none', fontSize: '0.78rem', borderRadius: '8px', whiteSpace: 'nowrap' }}
                                                >
                                                    {btnLabel}
                                                </Button>
                                            </Box>
                                        );
                                    }
                                    else {
                                        const value = column.selector ? column.selector(row) : null;
                                        cellContent = value;
                                    }

                                    return (
                                        <TableCell 
                                            key={column.accessorKey}
                                            sx={{ p: 1.5, fontSize: '0.875rem'}}>
                                            {cellContent}
                                        </TableCell>
                                    );
                                })}
                            </TableRow>
                        ))}
                        
                        {/* Empty state if no data */}
                        {processedData.length === 0 && (
                            <TableRow>
                                <TableCell colSpan={columns.length} align="center" sx={{ py: 4 }}>
                                    <Typography color="textSecondary" variant="body1">
                                        No requirements found matching the current filters.
                                    </Typography>
                                </TableCell>
                            </TableRow>
                        )}
                    </TableBody>
                </Table>
            </TableContainer>
          
                </div>
<div className="card-footer d-flex align-items-center justify-content-between" style={{ padding: '10px 25px' }}>
    <p className="text-muted mb-0">
        Showing <strong>{((currentPage - 1) * limit) + 1}</strong> – <strong>{Math.min(currentPage * limit, totalRows)}</strong> of <strong>{totalRows}</strong> entries
    </p>

    <nav aria-label="Page navigation">
        <ul className="pagination mb-0">
            {/* First Page */}
            <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                <button className="page-link" onClick={() => setCurrentPage(1)}>« First</button>
            </li>

            {/* Previous */}
            <li className={`page-item ${currentPage <= 1 ? 'disabled' : ''}`}>
                <button className="page-link" onClick={() => setCurrentPage(prev => prev - 1)}>&laquo;</button>
            </li>

            {/* Dynamic Page Numbers */}
            {pages.map(pageNum => (
                <li key={pageNum} className={`page-item ${currentPage === pageNum ? 'active' : ''}`}>
                    <button className="page-link" onClick={() => setCurrentPage(pageNum)}>
                        {pageNum}
                    </button>
                </li>
            ))}

            {/* Next */}
            <li className={`page-item ${currentPage >= maxPage ? 'disabled' : ''}`}>
                <button className="page-link" onClick={() => setCurrentPage(prev => prev + 1)}>&raquo;</button>
            </li>

            {/* Last Page */}
            <li className={`page-item ${currentPage === maxPage ? 'disabled' : ''}`}>
                <button className="page-link" onClick={() => setCurrentPage(maxPage)}>Last »</button>
            </li>
        </ul>
    </nav>
                </div>

              </div>

            </div>
          </div>

        </div>
      </div>
    </>
  );
}
export default SelfRequire;
